module.exports = __webpack_public_path__ + "static/liam_ackerman-cd4900f66426d6f0d5520b1b0720d3ca.jpg";